import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();


export const getCourseOfferingApi = async (url:string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/CourseOffering/GetAllCourseOffering`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCourseOfferingByPaginationApi = async (
    url:string,
    page: number,
    itemsPerPage: number,
    selectedCourseType: string | null,
    searchTerm: string
) => {
    const token = cookies.get('authToken');
    const params = new URLSearchParams();
    params.append("pageNumber", page.toString());
    params.append("pageSize", itemsPerPage.toString());
    params.append("selectedCourseType", selectedCourseType.toString());
    params.append("searchTerm", searchTerm.toString());
    try {
        const response = await axios.get(
            `${url}/CourseOffering/GetByPagination?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const addCourseOfferingApi = async (
    CourseId: string,
    CourseTypeId: string,
    Fees : number,
    Timings:string[],
    url:string
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/CourseOffering/Create`, {
            CourseId,
            CourseTypeId,
            Fees,
            Timings
        },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        return response.data;
    } catch (error) {
        console.error('API Error', error);
        throw error
    }
}

export const updateCourseOfferingApi = async (
    id: string,
    CourseId: string,
    CourseTypeId: string,
    Fees : number,
    timings: {
        id: string | null;
        time: string;
    }[],
    timingsToDelete: string[] | null,
    url:string
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/CourseOffering/update`, {
            id,
            CourseId,
            CourseTypeId,
            Fees,
            timings,
            timingsToDelete
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
        )
        return response.data;
    } catch (error) {
        console.error('API Error', error);
        throw error
    }
}

export const deleteCourseOfferingApi = async (id: string, url:string) => {
    const token = cookies.get('authToken');

    try {

        const response = await axios.request({
            method: "DELETE",
            url: `${url}/CourseOffering/Delete`,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            data: {
                id,
            },
        });
        return response.data;

    } catch (error) {
        console.error(error)
        throw error;
    }
}